module.exports = __webpack_public_path__ + "img/structureImg4.4f925ffb.svg";